import React from "react";
import { ToastContainer } from "react-toastify";

const FooterPortal = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="h-11 flex items-center px-8 text-sm bg-sky-900 text-white">
      <div className="w-full max-w-[90rem] md:px-8 text-center">
        <div>Copyright © {year} APJII. All rights reserved.</div>
      </div>
      <ToastContainer />
    </footer>
  );
};

export default FooterPortal;
